import {calculateDiscountAmount, getShortDate, calculatePaidDiscountAmount} from "./commonHelper";
import {getEarningCSVDataLink} from "./earningCSVDownloadHelper";
import {sortTableByMonth} from "../filter";

export const getEarningsTable = (monthsBasedData, discount, accountData, email) => {
    monthsBasedData = Object.fromEntries(Object.entries(monthsBasedData));
    let tableRowsArr = [];
    for (const month in monthsBasedData) {
        let tableCol = [];
        let dateObj = new Date(month);
        tableCol.push(getShortDate(dateObj));
        let totalNumberOfAcc = monthsBasedData[month].billingInfos.length;
        console.log(monthsBasedData[month]);
        let totalNumberOfActiveAcc = monthsBasedData[month].billedAccountsCount;
        tableCol.push(totalNumberOfActiveAcc.toString() + " out of " + totalNumberOfAcc.toString() + " (" + (totalNumberOfActiveAcc * 100 / totalNumberOfAcc).toFixed(2) + "%)");
        let total = monthsBasedData[month].totalBillingAmount.toFixed(2);
        tableCol.push(total);
        let totalDiscountAmount = calculatePaidDiscountAmount(monthsBasedData[month].billingInfos, 100);
        tableCol.push(totalDiscountAmount);
        let discountAmount = calculatePaidDiscountAmount(monthsBasedData[month].billingInfos, discount);
        if (email === "sandy@menu2order.com") {
            if (dateObj.getTime() <= 1664560800000) discountAmount += " (paid)";
        }

        if (email === "info@orderspar.com.au") {
            if (dateObj.getTime() <= 1682899200000) discountAmount += " (paid)";
        }

        tableCol.push(discountAmount);
        let detailsBtn = getEarningCSVDataLink("details_" + month, monthsBasedData[month].billingInfos, accountData.getAccountsObj(), discount);
        tableCol.push(detailsBtn);
        tableRowsArr.push(tableCol);
    }
    return tableRowsArr.sort(sortTableByMonth).slice(0, 12);
}
